import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/recharge/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

export function detailInfo(rechargeId) {
  return request.send({
    url: `/pmy/sys/recharge/info?rechargeId=${rechargeId}`,
    method: "get",
  });
}
